export default "<div class=\"pis__table\">\n  <pis-conditions></pis-conditions>\n</div>\n";